<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-title border-bottom p-3 mb-0 header-title">Manual Create Candidate</div>
          <div class="card-body">
            <b-form
            @submit.prevent="submitContact">
              <div class="row">
                <div class="col-md-6 m-auto text-center" 
                  v-if="model.id">
                  <form>
                    <img
                      src="@assets/images/users/avatar-6.jpg"
                      alt
                      class="avatar-xxl rounded-circle"
                    />
                  </form>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">First Name</label>
                    <input 
                      type="text" 
                      class="form-control"
                      placeholder="First Name"
                      v-model="model.first_name"
                    >
                  </div>
                  <div class="form-group">
                    <label for="">Last Name</label>
                    <input 
                      type="text" 
                      class="form-control"
                      placeholder="Last Name"
                      v-model="model.last_name"
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <DropDown 
                    placeholder="Select a Gender"
                    label="Gender"
                    :name.sync="model.gender"
                    :options="gender_list" 
                    v-model="model.gender"
                  />
                  <div class="form-group">
                    <label for="">Summary</label>
                    <textarea 
                      class="form-control"
                      placeholder="Summary"
                      v-model="model.summary"
                    >
                    </textarea>
                  </div>
                  <div class="form-group">
                    <label for="">Country</label>
                    <input 
                      type="text" 
                      class="form-control"
                      placeholder="Country"
                      v-model="model.country"
                    >
                  </div>
                  <div class="form-group">
                    <label for="">Location in This Country (City)</label>
                    <input 
                      type="text" 
                      class="form-control"
                      placeholder="Enter City"
                      v-model="model.city"
                    >
                  </div>

                 <!-- <DropDown 
                    label="Industry"
                    :name.sync="model.industry"
                    :options="industry_options"
                  /> -->

                </div>
              </div>
              <hr>
              <h5>Contact Information</h5>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="">Email Address</label>
                    <input 
                      type="email" 
                      v-model="model.email"
                      placeholder="Please Enter your email"
                      class="form-control"
                    >
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for="">Contact No</label>
                      <input 
                        type="text" 
                        class="form-control"
                        v-model="model.contact_no"
                        placeholder="Enter Contact No"
                      >
                    </div>

                    <DropDown 
                      label="Type"
                      :name.sync="model.contact_type"
                      v-model="model.contact_type"
                      :options="contact_types_option"
                      class="col-md-6"
                    />
                  </div>
                  <div class="form-group">
                    <label for="">Date of Birth</label>
                    <flat-pickr
                      v-model="model.date_of_birth"
                      class="form-control"
                      placeholder="Enter your Date of birth"
                    ></flat-pickr>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary btn-block mt-2" type="submit"><i class="uil-check"></i> Save</button>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    
  </Layout>
</template>

<script>
import Layout from '@layouts/default'
/* import InputTag from 'vue-input-tag' */
import { mapActions } from 'vuex'
import DropDown from '@components/form/dropdown.vue'


export default {
  data(){
    return {
      model:{
        email:'',
        first_name:'',
        last_name:'',
        contact_no:'',
        contact_type:'home',
        date_of_birth:'',
        gender:'',
        /* industry:null, */
        country:'',
        city:'',
        summary:''
      },
      contact_types_option:[
        { value: 'home', text: 'Home' },
        { value: 'work', text: 'Work' },
        { value: 'mobile', text: 'Mobile' }
      ],
      gender_list:[
        { value: null, text: 'Please select a Gender' },
        { value: 'Male', text: 'Male' },
        { value: 'Female', text: 'Female' }
      ],
      /* industry_options: [
        {text:'Enter Industry', value:null},
        {text:'Accounting', value:'Accounting'},
        {text:'Airlines/Aviation', value:'Airlines/Aviation'},
        {text:'Alternative Dispute Resolution', value:'Alternative Dispute Resolution'},
        {text:'Alternative Medicine', value:'Alternative Medicine'},
        {text:'Animation', value:'Animation'},
        {text:'Apparel & Fashion', value:'Apparel & Fashion'},
        {text:'Architecture & Planning', value:'Architecture & Planning'},
        {text:'Arts & Crafts', value:'Arts & Crafts'},
        {text:'Automotive', value:'Automotive'},
        {text:'Aviation & Aerospace', value:'Aviation & Aerospace'},
        {text:'Banking', value:'Banking'},
        {text:'Biotechnology', value:'Biotechnology'},
        {text:'Broadcast Media', value:'Broadcast Media'},
        {text:'Building Materials', value:'Building Materials'},
        {text:'Business Supplies & Equipment', value:'Business Supplies & Equipment'},
        {text:'Capital Markets', value:'Capital Markets'},
        {text:'Chemicals', value:'Chemicals'},
        {text:'Civic & Social Organization', value:'Civic & Social Organization'},
        {text:'Civil Engineering', value:'Civil Engineering'},
        {text:'Commercial Real Estate', value:'Commercial Real Estate'},
        {text:'Computer & Network Security', value:'Computer & Network Security'},
        {text:'Computer Games', value:'Computer Games'},
        {text:'Computer Hardware', value:'Computer Hardware'},
        {text:'Computer Networking', value:'Computer Networking'},
        {text:'Computer Software', value:'Computer Software'},
        {text:'Construction', value:'Construction'},
        {text:'Consumer Electronics', value:'Consumer Electronics'},
        {text:'Consumer Goods', value:'Consumer Goods'},
        {text:'Consumer Services', value:'Consumer Services'},
        {text:'Cosmetics', value:'Cosmetics'},
        {text:'Dairy', value:'Dairy'},
        {text:'Defense & Space', value:'Defense & Space'},
        {text:'Design', value:'Design'},
        {text:'E-learning', value:'E-learning'},
        {text:'Education Management', value:'Education Management'},
        {text:'Electrical & Electronic Manufacturing', value:'Electrical & Electronic Manufacturing'},
        {text:'Entertainment', value:'Entertainment'},
        {text:'Environmental Services', value:'Environmental Services'},
        {text:'Events Services', value:'Events Services'},
        {text:'Executive Office', value:'Executive Office'},
        {text:'Facilities Services', value:'Facilities Services'},
        {text:'Farming', value:'Farming'},
        {text:'Financial Services', value:'Financial Services'},
        {text:'Fine Art', value:'Fine Art'},
        {text:'Fishery', value:'Fishery'},
        {text:'Food & Beverages', value:'Food & Beverages'},
        {text:'Food Production', value:'Food Production'},
        {text:'Fundraising', value:'Fundraising'},
        {text:'Furniture', value:'Furniture'},
        {text:'Gambling & Casinos', value:'Gambling & Casinos'},
        {text:'Glass, Ceramics & Concrete', value:'Glass, Ceramics & Concrete'},
        {text:'Government Administration', value:'Government Administration'},
        {text:'Government Relations', value:'Government Relations'},
        {text:'Graphic Design', value:'Graphic Design'},
        {text:'Health, Wellness & Fitness', value:'Health, Wellness & Fitness'},
        {text:'Higher Education', value:'Higher Education'},
        {text:'Hospital & Health Care', value:'Hospital & Health Care'},
        {text:'Hospitality', value:'Hospitality'},
        {text:'Human Resources', value:'Human Resources'},
        {text:'Import & Export', value:'Import & Export'},
        {text:'Individual & Family Services', value:'Individual & Family Services'},
        {text:'Industrial Automation', value:'Industrial Automation'},
        {text:'Information Services', value:'Information Services'},
        {text:'Information Technology & Services', value:'Information Technology & Services'},
        {text:'Insurance', value:'Insurance'},
        {text:'International Affairs', value:'International Affairs'},
        {text:'International Trade & Development', value:'International Trade & Development'},
        {text:'Internet', value:'Internet'},
        {text:'Investment Banking', value:'Investment Banking'},
        {text:'Investment Management', value:'Investment Management'},
        {text:'Judiciary', value:'Judiciary'},
        {text:'Law Enforcement', value:'Law Enforcement'},
        {text:'Law Practice', value:'Law Practice'},
        {text:'Legal Services', value:'Legal Services'},
        {text:'Legislative Office', value:'Legislative Office'},
        {text:'Leisure, Travel & Tourism', value:'Leisure, Travel & Tourism'},
        {text:'Libraries', value:'Libraries'},
        {text:'Logistics & Supply Chain', value:'Logistics & Supply Chain'},
        {text:'Luxury Goods & Jewelry', value:'Luxury Goods & Jewelry'},
        {text:'Machinery', value:'Machinery'},
        {text:'Management Consulting', value:'Management Consulting'},
        {text:'Maritime', value:'Maritime'},
        {text:'Market Research', value:'Market Research'},
        {text:'Marketing & Advertising', value:'Marketing & Advertising'},
        {text:'Mechanical Or Industrial Engineering', value:'Mechanical Or Industrial Engineering'},
        {text:'Media Production', value:'Media Production'},
        {text:'Medical Device', value:'Medical Device'},
        {text:'Medical Practice', value:'Medical Practice'},
        {text:'Mental Health Care', value:'Mental Health Care'},
        {text:'Military', value:'Military'},
        {text:'Mining & Metals', value:'Mining & Metals'},
        {text:'Motion Pictures & Film', value:'Motion Pictures & Film'},
        {text:'Museums & Institutions', value:'Museums & Institutions'},
        {text:'Music', value:'Music'},
        {text:'Nanotechnology', value:'Nanotechnology'},
        {text:'Newspapers', value:'Newspapers'},
        {text:'Non-profit Organization Management', value:'Non-profit Organization Management'},
        {text:'Oil & Energy', value:'Oil & Energy'},
        {text:'Online Media', value:'Online Media'},
        {text:'Outsourcing/Offshoring', value:'Outsourcing/Offshoring'},
        {text:'Package/Freight Delivery', value:'Package/Freight Delivery'},
        {text:'Packaging & Containers', value:'Packaging & Containers'},
        {text:'Paper & Forest Products', value:'Paper & Forest Products'},
        {text:'Performing Arts', value:'Performing Arts'},
        {text:'Pharmaceuticals', value:'Pharmaceuticals'},
        {text:'Philanthropy', value:'Philanthropy'},
        {text:'Photography', value:'Photography'},
        {text:'Plastics', value:'Plastics'},
        {text:'Political Organization', value:'Political Organization'},
        {text:'Primary/Secondary Education', value:'Primary/Secondary Education'},
        {text:'Printing', value:'Printing'},
        {text:'Professional Training & Coaching', value:'Professional Training & Coaching'},
        {text:'Program Development', value:'Program Development'},
        {text:'Public Policy', value:'Public Policy'},
        {text:'Public Relations & Communications', value:'Public Relations & Communications'},
        {text:'Public Safety', value:'Public Safety'},
        {text:'Publishing', value:'Publishing'},
        {text:'Railroad Manufacture', value:'Railroad Manufacture'},
        {text:'Ranching', value:'Ranching'},
        {text:'Real Estate', value:'Real Estate'},
        {text:'Recreational Facilities & Services', value:'Recreational Facilities & Services'},
        {text:'Religious Institutions', value:'Religious Institutions'},
        {text:'Renewables & Environment', value:'Renewables & Environment'},
        {text:'Research', value:'Research'},
        {text:'Restaurants', value:'Restaurants'},
        {text:'Retail', value:'Retail'},
        {text:'Security & Investigations', value:'Security & Investigations'},
        {text:'Semiconductors', value:'Semiconductors'},
        {text:'Shipbuilding', value:'Shipbuilding'},
        {text:'Sporting Goods', value:'Sporting Goods'},
        {text:'Sports', value:'Sports'},
        {text:'Staffing & Recruiting', value:'Staffing & Recruiting'},
        {text:'Supermarkets', value:'Supermarkets'},
        {text:'Telecommunications', value:'Telecommunications'},
        {text:'Textiles', value:'Textiles'},
        {text:'Think Tanks', value:'Think Tanks'},
        {text:'Tobacco', value:'Tobacco'},
        {text:'Translation & Localization', value:'Translation & Localization'},
        {text:'Transportation/Trucking/Railroad', value:'Transportation/Trucking/Railroad'},
        {text:'Utilities', value:'Utilities'},
        {text:'Venture Capital & Private Equity', value:'Venture Capital & Private Equity'},
        {text:'Veterinary', value:'Veterinary'},
        {text:'Warehousing', value:'Warehousing'},
        {text:'Wholesale', value:'Wholesale'},
        {text:'Wine & Spirits', value:'Wine & Spirits'},
        {text:'Wireless', value:'Wireless'},
        {text:'Writing & Editing', value:'Writing & Editing'},
      ] */
    }
  },
  components:{Layout, DropDown},
  methods:{
    ...mapActions('user', ['findByToken', 'step_3']),
    submitContact(){
      /* this.model.manual = true */
      this.model.type = 'candidate'
      this.step_3(this.model).then(res => {
        this.$router.push('/candidate/step_4?type=candidate&id=' + res.data._id)
      })
    }
  },
  mounted() {
    if(this.$route.query.id){
      this.findByToken({
        id:this.$route.query.id,
        type:'candidate'
      }).then(user => {
        this.model.email = user.data.user.email
        this.model.id = user.data.user._id
        this.model.first_name = user.data.user.first_name
        this.model.last_name = user.data.user.last_name
        this.model.summary = user.data.user.summary
        this.model.contact_no = user.data.user.contact_no
        this.model.contact_type = user.data.user.contact_type
        this.model.date_of_birth = user.data.user.date_of_birth
        this.model.gender = user.data.user.gender.toString()
        if(user.data.step == 3){
          this.$router.push('/candidate/step_4?type=candidate&id=' + this.$route.query.id)
        }
      })
    }
    
  }
}
</script>